import React, { useState } from 'react';
import Image from 'next/image';
import PropTypes from 'prop-types';

const propTypes = {
  height: PropTypes.number.isRequired,
  width: PropTypes.number.isRequired,
  src: PropTypes.string.isRequired,
  fallbackSrc: PropTypes.string.isRequired,
};

const ImageWithFallback = ({ src, fallbackSrc, ...restProps }) => {
  const [imgSrc, setImgSrc] = useState(src);

  return (
    <Image
      // eslint-disable-next-line react/jsx-props-no-spreading
      {...restProps}
      src={imgSrc}
      onError={() => setImgSrc(fallbackSrc)}
    />
  );
};

ImageWithFallback.propTypes = propTypes;

export default ImageWithFallback;
